import {
  TAclGroup,
  TAclGroupUser,
  TAvatarResponse,
  TUpdateAvatarPayload,
  TUserInfo,
} from 'features/auth/types';
import { baseApi } from 'lib/rtkQuery/baseApi';
import { QueryTags } from 'lib/rtkQuery/constants';
import { invalidatesTags } from 'lib/rtkQuery/helpers';
import { QueryResponse } from 'lib/rtkQuery/types';
import qs from 'qs';

const endpoint = '/users';
const clientId = import.meta.env.VITE_APP_OAUTH_CLIENT_ID;
const clientSecret = import.meta.env.VITE_APP_OAUTH_CLIENT_SECRET;

export const authQueryApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [QueryTags.UserDetail],
  })
  .injectEndpoints({
    endpoints: builder => ({
      userLogin: builder.mutation({
        query: data => ({
          url: '/oauth/token',
          method: 'POST',
          customHeader: {
            Authorization: `Basic ${btoa(`${clientId}:${clientSecret}`)}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: qs.stringify(data),
        }),
      }),

      GetCurrentUser: builder.query<TUserInfo, unknown>({
        query: () => ({
          url: `/users/current-user`,
          method: 'GET',
        }),
        providesTags: [QueryTags.UserDetail],
      }),

      RevokeToken: builder.mutation<QueryResponse<string>, undefined>({
        query: () => ({
          url: `${endpoint}/Revoke`,
          method: 'POST',
          manuallyHandlingErrorMsg: true,
          disableSpinner: true,
        }),
      }),

      GetAclGroupByCode: builder.query<TAclGroup, string>({
        query: code => ({
          url: `/acl_group/${code}`,
          method: 'GET',
        }),
      }),

      GetACLDetailByUser: builder.query<TAclGroupUser, string>({
        query: userName => ({
          url: `/acl_group_user/${userName}`,
          method: 'GET',
        }),
      }),

      UpdateCurrentUserAvatar: builder.mutation<
        QueryResponse<TAvatarResponse>,
        TUpdateAvatarPayload
      >({
        query: ({ file }) => {
          const formData = new FormData();
          formData.append('file', file);
          return {
            url: `/users/current-user/image`,
            method: 'PATCH',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          };
        },
        invalidatesTags: invalidatesTags([QueryTags.UserDetail]),
      }),
    }),
  });

export const {
  useUserLoginMutation,
  useGetCurrentUserQuery,
  useRevokeTokenMutation,
  useGetACLDetailByUserQuery,
  useGetAclGroupByCodeQuery,
  useUpdateCurrentUserAvatarMutation,
} = authQueryApi;
